import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/colors_and_type.css';
import './styles/site.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply the persisted theme before first paint (defaults to dark).
const savedTheme = localStorage.getItem('pn-theme') || 'dark';
document.documentElement.setAttribute('data-theme', savedTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//  <React.StrictMode>
    <App />
//  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();